import { ApolloQueryResult } from "@apollo/client";
import { useEffect, useState } from "react";
import { AccountRole, AccountsQuery, useAccountsLazyQuery } from "../graphql";

const PER_PAGE = 100;

function useAccounts(
    initialRole: AccountRole,
    initialSearch?: string
): {
  items: AccountsQuery["accounts"]["nodes"];
  hasNextPage?: boolean;
  loading: boolean;
  totalCount: number;
  loadMore?: () => Promise<ApolloQueryResult<AccountsQuery>>;
  refresh?: ({ search }: { search?: string }) => void;
} {
    const [{ role, search }, setQuery] = useState({
        role: initialRole,
        search: initialSearch
    });

    const variables = {
        page: 1,
        pageLimit: PER_PAGE,
        role,
        search
    };

    const [request, { loading, data, fetchMore }] = useAccountsLazyQuery({
        variables,
        notifyOnNetworkStatusChange: true
    });

    useEffect(() => {
        request();
    }, [request]);

    const refresh = ({ search: newSearch }) => {
        if (search !== newSearch) {
            setQuery({ role, search: newSearch });
        }
    };

    const loadMore = () => {
        return fetchMore({
            variables: {
                ...variables,
                page: data?.accounts?.pageInfo?.nextPage || 1
            },
            updateQuery: (previousResult, { fetchMoreResult }) => {
                const newNodes = fetchMoreResult.accounts.nodes;

                return newNodes.length
                    ? {
                        ...fetchMoreResult,
                        accounts: {
                            ...fetchMoreResult.accounts,
                            nodes: [...previousResult.accounts.nodes, ...newNodes]
                        }
                    }
                    : previousResult;
            }
        });
    };
    return {
        totalCount: data?.accounts?.totalCount || 0,
        items: data?.accounts?.nodes || [],
        hasNextPage: data?.accounts?.pageInfo?.hasNextPage,
        loading,
        loadMore,
        refresh
    };
}
export { useAccounts };
